<div class="pp lm">

  <!-- The product first: three of its screens on the stage (product-hero.data.ts, the story's own
       picture), opening in the lightbox with the others (owner 2026-10-10: as Dock Town). -->
  <div class="pp-stage">
    <header class="pp-wrap pp-intro">
      <div class="pp-intro-main">
        <span class="pp-platform">
          <img src="./assets/third-parties/logo/ios-apps.webp" alt="">
          iOS App
        </span>
        <h1 class="pp-name">
          <img [src]="icon" alt="" class="pp-icon" width="72" height="72">
          <span>LangMi</span>
        </h1>
        <p class="pp-pitch">Learn a language by living a story: move to London, choose your lines in real dialogues, say them out loud and keep every word you meet</p>
        <ul class="pp-facts" aria-label="At a glance">
          <li *ngFor="let f of facts">{{ f }}</li>
        </ul>
      </div>

      <div class="pp-act">
        <div class="pp-cta">
          <a class="codigrate-button" *ngIf="released" [href]="appStoreUrl" target="_blank" rel="noopener" (click)="onInstall()"><p>Download on the App Store</p></a>
          <span class="codigrate-button cp-btn-neutral" *ngIf="!released"><p>Coming Soon to the App Store</p></span>
          <a class="codigrate-button cp-btn-neutral" [attr.href]="URLS.langmi + '#support'" (click)="jumpTo( 'support', $event )"><p>Get Support</p></a>
        </div>
      </div>
    </header>

    <div class="pp-wrap">
      <button class="pp-shot pp-shot-wide lm-hero" type="button" *ngIf="heroShot as shot; else heroFigure" (click)="openLightbox( shot )" [attr.aria-label]="'Enlarge: ' + shot.name">
        <img [src]="hero.src" [alt]="hero.alt" [width]="hero.width" [height]="hero.height" loading="eager" decoding="async">
      </button>
      <ng-template #heroFigure>
        <figure class="pp-shot pp-shot-wide lm-hero">
          <img [src]="hero.src" [alt]="hero.alt" [width]="hero.width" [height]="hero.height" loading="eager" decoding="async">
        </figure>
      </ng-template>
    </div>
  </div>

  <div class="pp-wrap">

    <!-- The stage's own words, under it -->
    <section class="lm-intro">
      <h2 class="lm-headline"><span class="lm-accent">{{ intro.accent }}</span> {{ intro.rest }}</h2>
      <p class="lm-text">{{ intro.description }}</p>
    </section>

    <!-- One section per thing the app does, one under the other (owner 2026-10-10, as Dock Town):
         the App Store picture's headline and its words, centred, and under them the screens as
         pictures of their own, each opening in the lightbox: one to three phones at one height,
         the mini games as a grid with their one-liners, learning together with its steps. -->
    <section class="lm-feature" *ngFor="let f of pictured; trackBy: trackFeature"
             [attr.data-layout]="f.layout" [attr.data-key]="f.key" [attr.id]="f.anchor || null" [attr.aria-labelledby]="'lm-feature-' + f.key">
      <div class="lm-feature-words">
        <h2 class="lm-headline" [id]="'lm-feature-' + f.key"><span class="lm-accent">{{ f.accent }}</span> {{ f.rest }}</h2>
        <p class="lm-text">{{ f.description }}</p>
      </div>
      <div class="lm-scenes">
        <figure class="lm-scene" *ngFor="let sc of f.scenes; trackBy: trackScene">
          <button type="button" class="lm-phone" (click)="enlarge( sc )" [attr.aria-label]="'Enlarge: ' + sc.name">
            <img [src]="src( sc )" [alt]="sc.alt" [width]="sc.width" [height]="sc.height" loading="lazy" decoding="async">
          </button>
          <figcaption *ngIf="sc.caption">
            <span class="lm-cap-name">{{ sc.name }}</span>
            <span class="lm-cap-line">{{ sc.caption }}</span>
          </figcaption>
        </figure>
      </div>
      <!-- learning together: how it goes, step by step, under the phone -->
      <div class="lm-together" *ngIf="f.key === 'together'">
        <ol class="lm-steps">
          <li *ngFor="let st of togetherSteps">
            <h3>{{ st.title }}</h3>
            <p>{{ st.description }}</p>
          </li>
        </ol>
        <p class="lm-note">Learning together needs LangMi PRO on both devices, signing in with Apple and an internet connection. Teachers see their students' finished chapters, lesson summaries and notes in one list. The teacher profile is for adults:
          <a class="lm-link" [routerLink]="URLS.langmiTeacherTerms">read the LangMi Teacher Terms</a>.</p>
      </div>
    </section>

    <!-- the twelve languages, a section of their own before the exercise types (owner 2026-10-12): each by its English name
         and its own -->
    <section class="pp-section" id="languages" tabindex="-1">
      <h2 class="pp-section-title">12 Languages</h2>
      <p class="lm-lead">The interface and the meaning of every line in your own language</p>
      <ul class="lm-boxes lm-languages">
        <li class="lm-box lm-language" *ngFor="let l of languages" [attr.lang]="l.code">
          <span class="lm-flag" aria-hidden="true"><img [src]="'./assets/flags/' + l.flag + '.svg'" alt="" width="56" height="42" loading="lazy" decoding="async"></span>
          <span class="lm-language-text">
            <h3>{{ l.name }}</h3>
            <p [attr.dir]="l.code === 'ar' ? 'rtl' : null">{{ l.native }}</p>
          </span>
          <!-- every language but English is on its way (owner 2026-10-12) -->
          <span class="lm-soon" *ngIf="l.code !== 'en'">Coming Soon</span>
        </li>
      </ul>
    </section>

    <!-- The three lists the app keeps on its own Science page (Settings > Help > The science behind
         it; owner 2026-10-10: "kutu kutu"): every exercise type, the science behind them, every mini
         game with its icon from the app; what else it does comes after them (owner 2026-10-10). -->
    <section class="pp-section" id="exercises" tabindex="-1">
      <h2 class="pp-section-title">All the Exercise Types</h2>
      <p class="lm-lead">Thirteen kinds, each working a different memory muscle; the mix is deliberate</p>
      <ul class="lm-boxes lm-kinds">
        <li class="lm-box" *ngFor="let k of kinds">
          <span class="lm-box-icon" aria-hidden="true"><app-icon [name]="k.icon"></app-icon></span>
          <h3>{{ k.name }}</h3>
          <p>{{ k.description }}</p>
        </li>
      </ul>
    </section>

    <section class="pp-section" id="science" tabindex="-1">
      <h2 class="pp-section-title">The Science Behind It</h2>
      <div class="lm-lead-row">
        <img class="lm-lead-art" src="./assets/product-lines/tools/langmi/science.webp" alt="" width="192" height="192" loading="lazy" decoding="async">
        <p class="lm-lead">Every part of LangMi leans on the science of learning. Here is what's behind the curtain</p>
      </div>
      <ul class="lm-boxes lm-science">
        <li class="lm-box" *ngFor="let s of science">
          <span class="lm-box-icon" aria-hidden="true"><app-icon [name]="s.icon"></app-icon></span>
          <h3>{{ s.name }}</h3>
          <p>{{ s.description }}</p>
        </li>
      </ul>
    </section>

    <section class="pp-section" id="mini-games" tabindex="-1">
      <h2 class="pp-section-title">All the Mini Games</h2>
      <p class="lm-lead">In a Blink, Say It! and Swipe It! are free on every plan; LangMi PRO opens the others, and every new game that comes</p>
      <ul class="lm-boxes lm-games">
        <li class="lm-box lm-game" *ngFor="let g of games">
          <img class="lm-game-icon" [src]="g.icon" alt="" width="192" height="192" loading="lazy" decoding="async">
          <div class="lm-game-words">
            <h3>{{ g.name }}</h3>
            <p>{{ g.line }}</p>
            <span class="lm-plan" *ngIf="g.pro">LangMi PRO</span>
          </div>
        </li>
      </ul>
    </section>

    <section class="pp-section">
      <h2 class="pp-section-title">What Else It Does</h2>
      <ul class="pp-list">
        <li *ngFor="let f of features">
          <h3>{{ f.title }}</h3>
          <p>{{ f.description }}</p>
        </li>
      </ul>
    </section>

    <section class="pp-section">
      <h2 class="pp-section-title">Questions</h2>
      <div class="pp-faq">
        <details class="pp-faq-item" *ngFor="let f of faq">
          <summary>{{ f.q }}</summary>
          <p>{{ f.a }}</p>
        </details>
      </div>
    </section>

    <!-- The app's Support URL in App Store Connect lands here, so the address stays on the page. -->
    <section class="pp-section" id="support" tabindex="-1">
      <h2 class="pp-section-title">Support</h2>
      <div class="lm-support">
        <p>Something not working, or a question about the app? Write to
          <a class="lm-link" [href]="'mailto:' + environmentCommon.company.email + '?subject=LangMi'">{{ environmentCommon.company.email }}</a>.
          A real person answers, usually within two working days. Please tell us your device model and iOS version and, if it helps, add a screenshot.</p>
        <ul class="lm-legal" aria-label="Legal">
          <li><a class="lm-link" [routerLink]="URLS.langmiPrivacy">LangMi Privacy Policy</a></li>
          <li><a class="lm-link" [routerLink]="URLS.langmiTerms">LangMi Terms of Use</a></li>
          <li><a class="lm-link" [routerLink]="URLS.langmiTeacherTerms">LangMi Teacher Terms</a></li>
        </ul>
      </div>
    </section>

    <!-- Lightbox: the shared one (src/styles/page/tool-lightbox.scss), as on every Apps & Plugins
         page. The picture over a frosted backdrop and one pill under it: previous, the picture's
         name, next, close. The arrow keys page through every picture and Escape closes. -->
    <div class="cp-lightbox" *ngIf="lightbox" role="dialog" aria-modal="true" [attr.aria-label]="lightbox.name" (click)="closeLightbox()">
      <figure class="cp-lightbox-inner" (click)="$event.stopPropagation()">
        <img [src]="lightbox.large" [alt]="lightbox.alt">
      </figure>
      <!-- the pictures on either side load while this one shows, so the arrows turn at once -->
      <img class="td-lb-preload" [src]="shotAt( -1 ).large" alt="">
      <img class="td-lb-preload" [src]="shotAt( 1 ).large" alt="">
      <div class="cp-lightbox-caption-row" (click)="$event.stopPropagation()">
        <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( -1, $event )" aria-label="Previous screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4.5 L7.5 12 L15 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <!-- as wide as the longest name (all are stacked in one cell), so the pill keeps its size -->
        <span class="cp-lb-seg td-lb-label">
          <span class="cp-lb-name">
            <span class="cp-lb-name-sizer" *ngFor="let s of shots" aria-hidden="true">{{ s.name }}</span>
            <span class="cp-lb-name-cur">{{ lightbox.name }}</span>
          </span>
        </span>
        <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( 1, $event )" aria-label="Next screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4.5 L16.5 12 L9 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <button class="cp-lb-seg cp-lb-close" type="button" (click)="closeLightbox()" aria-label="Close">&times;</button>
      </div>
    </div>

    <section class="cp-closing">
      <h2 class="cp-closing-title">Start Your Story</h2>
      <p class="cp-closing-text">Move to London and learn English one chapter at a time</p>
      <a class="codigrate-button cp-closing-btn" *ngIf="released" [href]="appStoreUrl" target="_blank" rel="noopener" (click)="onInstall()"><p>Download on the App Store</p></a>
      <!-- until the listing is public: the same Coming Soon as at the top -->
      <span class="codigrate-button cp-closing-btn cp-btn-neutral" *ngIf="!released"><p>Coming Soon to the App Store</p></span>
      <!-- the legal links at the very foot of the page, not in the hero (owner 2026-10-10) -->
      <p class="cp-note lm-closing-note">No ads and no tracking, and no account needed to learn.
        <a class="lm-link" [routerLink]="URLS.langmiPrivacy">Read the LangMi Privacy Policy</a> and the
        <a class="lm-link" [routerLink]="URLS.langmiTerms">Terms of Use</a></p>
    </section>

  </div>

</div>
